// Доля ширины canvas под зоной стрельбы (слева). Правая часть — джойстик.
// Раньше было 0.5 (50/50): мобильные игроки жаловались, что стрельба
// «съедает» половину поля и палец закрывает врагов, а двигаться приходится
// только в правой узкой полосе. 0.25 = 25% слева под стрельбу, 75% справа
// под движение — игроку комфортнее: стрелять можно одной точкой ближе к
// краю, всё остальное — пространство для большого пальца.
export const MOBILE_SHOOT_ZONE_RATIO = 0.25;
